import { memo, useMemo } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { FormikProps } from 'formik';
import { MButton, MInput } from '@Components/Base';

import styles from './sim-addon-notification.module.css';

import { initFormikValuesType } from './types';

interface SimAddonNotificationProps {
  title: string;
  textSuccessBtn: string;
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  existingPackage?: string;
  handleSuccess: () => void;
  handleCancel: () => void;
  textCancelBtn?: string;
}

const SimAddonNotification: React.FC<SimAddonNotificationProps> = ({
  title,
  isModalOpen,
  textSuccessBtn,
  textCancelBtn = 'No, Thanks',
  formik,
  handleSuccess,
  handleCancel,
  existingPackage = '',
}) => {
  const customButtons = useMemo(() => {
    return [
      <MButton key="back" type="tertiary" onClick={handleCancel}>
        {textCancelBtn}
      </MButton>,
      <MButton key="submit" type="primary" onClick={handleSuccess}>
        {textSuccessBtn}
      </MButton>,
    ];
  }, [textCancelBtn, textSuccessBtn, handleSuccess, handleCancel]);

  return (
    <Modal
      open={isModalOpen}
      onOk={handleSuccess}
      onCancel={handleCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        </Flex>
        <div className={styles.fieldsSection}>
          <div>
            <Typography.Text>Existing Package:</Typography.Text>
            <div>{existingPackage}</div>
          </div>
          <div>
            <Typography.Text>Recommend Package:</Typography.Text>
            <MInput
              name="recommendPackage"
              onChange={(input) =>
                formik.setFieldValue('recommendPackage', input.target.value)
              }
              placeholder="Type Recommend Package"
            />
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default memo(SimAddonNotification);
